import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/AuthContext';
import { useBusinessTheme } from '../contexts/BusinessThemeContext';
import MainCalendar from '../components/calendar/MainCalendar';
import { Container, Typography } from '@mui/material';
import '../calendar.css';
import CalendarGuide from '../components/onboarding/CalendarGuide';
import OfflineBanner from '../components/common/OfflineBanner';

const CalendarPage: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const { businessId } = useBusinessTheme();
    const location = useLocation();
    const navigationState = location.state as { date?: string; appointmentId?: string } | null;

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    return (
        <>
            <Helmet>
                <title>Calendar | MindShare Calendar</title>
            </Helmet>
            
            {/* Offline banner - only shown on calendar view */}
            <OfflineBanner />
            
            <Container 
                maxWidth={false} 
                disableGutters 
                sx={{
                    position: 'relative',
                    isolation: 'isolate',
                    backgroundColor: 'transparent',
                    height: { xs: 'calc(100vh - 55px)', sm: 'calc(100vh - 64px)' },
                    overflow: 'hidden',
                    '&::before': businessId ? {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(/api/images/${businessId})`,
                        backgroundSize: '550px auto',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        opacity: 0.5,
                    } : {},
                }}
            >
                <MainCalendar 
                    initialDate={navigationState?.date ? new Date(navigationState.date) : undefined}
                    highlightAppointmentId={navigationState?.appointmentId}
                />
            </Container>
        </>
    );
};

export default CalendarPage; 